"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { ThemeProvider } from "next-themes";
import { Suspense, useState } from "react";
import { YoursProvider } from "yours-wallet-provider";
import { AccentProvider } from "@/components/accent-provider";
import { OneSatProvider } from "@/components/providers/onesat-provider";
import { Toaster } from "@/components/ui/sonner";
import { IdentityProvider } from "@/contexts/identity-context";

/**
 * Client-side provider stack, extracted from the root layout so the layout
 * itself can be a server component (metadata export + server-rendered HTML
 * for crawlers and agents that don't execute JavaScript).
 */
export function Providers(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  const pathname = usePathname();
  let t1;
  if ($[0] !== children) {
    t1 = <Suspense fallback={null}>{children}</Suspense>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  let t2;
  if ($[2] !== content || $[3] !== pathname) {
    t2 = pathname === "/signer" ? content : <IdentityProvider><YoursProvider><OneSatProvider>{content}</OneSatProvider></YoursProvider></IdentityProvider>;
    $[2] = content;
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const walletContent = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Toaster />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== walletContent) {
    t4 = <ThemeProvider attribute="class" defaultTheme="system" disableTransitionOnChange={true} enableSystem={true}><AccentProvider>{walletContent}{t3}</AccentProvider></ThemeProvider>;
    $[6] = walletContent;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== queryClient || $[9] !== t4) {
    t5 = <QueryClientProvider client={queryClient}>{t4}</QueryClientProvider>;
    $[8] = queryClient;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp() {
  return new QueryClient();
}